import clsx from "clsx";
import { memo, type ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface DialogAwareContentContainerProps {
    children: ReactNode;
    isDialog?: boolean;
    className?: string;
}

const baseClasses = "flex flex-col gap-2";

export const DialogAwareContentContainer = memo(function DialogAwareContentContainer({
    children,
    isDialog,
    className,
}: DialogAwareContentContainerProps) {
    const baseClassName = clsx(
        baseClasses,
        {
            "px-0": isDialog,
        },
        className,
    );

    return <div className={twMerge(baseClassName)}>{children}</div>;
});

DialogAwareContentContainer.displayName = "DialogAwareContentContainer";
